import { Box, Avatar, Typography } from '@mui/material';
import { colors } from '../../../styles/colors';

const sizeMap = {
  small: { avatar: 22, font: 10.5, text: 12.5 },
  medium: { avatar: 26, font: 11.5, text: 13 },
  large: { avatar: 36, font: 15, text: 14 },
} as const;

interface UserAvatarProps {
  initial: string;
  name: string;
  size?: 'small' | 'medium' | 'large';
}

function getRandomColorByName(str: string) {
  if (str === 'Nenhum') return colors.brand.textMuted;

  const palette = [
    '#F59E42', // orange
    '#F472B6', // pink
    '#60A5FA', // blue
    '#34D399', // green
    '#FBBF24', // yellow
    '#A78BFA', // purple
    '#F87171', // red
    '#38BDF8', // sky
    '#FCD34D', // gold
    '#4ADE80', // emerald
  ];
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const idx = Math.abs(hash) % palette.length;
  return palette[idx];
}

export const UserAvatar = ({ initial, name, size = 'medium' }: UserAvatarProps) => {
  const dims = sizeMap[size];
  const avatarColor = getRandomColorByName(name || initial);
  const isEmpty = name === 'Nenhum';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
      <Avatar
        sx={{
          width: dims.avatar,
          height: dims.avatar,
          flexShrink: 0,
          bgcolor: `${avatarColor}26`,
          color: avatarColor,
          border: `1px solid ${avatarColor}55`,
          fontSize: `${dims.font}px`,
          fontWeight: 600,
        }}
      >
        {initial}
      </Avatar>
      <Typography
        variant="body2"
        noWrap
        title={name}
        sx={{
          color: isEmpty ? colors.brand.textMuted : colors.brand.textStrong,
          fontSize: `${dims.text}px`,
        }}
      >
        {name}
      </Typography>
    </Box>
  );
};
